/**
 * Languages the user can select in their profile.
 *
 * The `value` is stored on the user (`user.lang`) and used as the app locale,
 * so it must match a key in the `localeData` map (see common/locales/index.tsx).
 */
export interface SupportedLanguage {
  value: string;
  label: string;
}

export const supportedLanguages: Array<SupportedLanguage> = [
  { value: "en-GB", label: "English" },
  { value: "de-DE", label: "Deutsch" },
  { value: "da-DK", label: "Dansk" },
];

/**
 * Normalise an arbitrary locale string (e.g. "en", "en-US", "de") onto one of
 * the selectable language values so the dropdown shows the right option.
 */
export function normalizeLanguage(lang?: string | null): string {
  if (!lang) return "en-GB";
  const exact = supportedLanguages.find((l) => l.value === lang);
  if (exact) return exact.value;
  const base = lang.split("-")[0].toLowerCase();
  const byBase = supportedLanguages.find(
    (l) => l.value.split("-")[0].toLowerCase() === base
  );
  return byBase?.value ?? "en-GB";
}
